import { type Content, Portal } from '@radix-ui/react-context-menu'
import React, {
  type ComponentPropsWithoutRef,
  type ElementRef,
  type ReactNode,
  forwardRef,
} from 'react'

import { StyledNewContextMenuContent } from './NewContextMenuContent.styles'

type NewContextMenuContentProps = ComponentPropsWithoutRef<typeof Content> & {
  children?: ReactNode
  'data-e2e'?: string
}

export const NewContextMenuContent = forwardRef<
  ElementRef<typeof Content>,
  NewContextMenuContentProps
>(({ children, 'data-e2e': dataE2e, ...props }, ref) => (
  <Portal>
    <StyledNewContextMenuContent data-e2e={dataE2e} ref={ref} {...props}>
      {children}
    </StyledNewContextMenuContent>
  </Portal>
))
